import { ReactElement } from 'react'
import { MuiIconMap } from '@ally/metronome-icons'

export interface StatusHistory {
  status: string
  eventDateTime: string
}

export interface WireEvent {
  fromAccountName: string
  fromAccountNickName?: string
  fromAccountNumber: string
  wireAmount: number
  wireFee?: number
  bankName: string
  recipientRoutingNumber: string
  recipientAccountNumber: string
  recipientName: string
  additionalInstructions?: string
}

export interface CheckOrderEvent {
  bankCode: string
  accountNumber: string
  accountName: string
  accountNickName?: string
  addressType: string
  firstName?: string
  middleName?: string
  lastName?: string
  businessName?: string
  attentionLine?: string
  poBox?: string
  addressLine1?: string
  addressLine2?: string
  addressLine3?: string
  addressLine4?: string
  city?: string
  stateCode?: string
  zip?: string
  countryCode?: string
}

export interface TransferEvent {
  fromAccountName?: string
  fromAccountNickName?: string
  fromAccountNumber?: string
  toAccountName?: string
  toAccountNickName?: string
  toAccountNumber?: string
  transferAmount: number
  transferFrequency: string
}

export interface InternalEvent extends TransferEvent {
  transferDate: string
}

export interface AchEvent extends TransferEvent {
  deliverOnDate: string
  fiservCustomerId: string
  fromAccountFinancialInstName: string
  fromAccountNameNumber: string
  fromAccountId: string
  fromAccountRoutingNumber: string
  fromAccountType: string
  toAccountFinancialInstName: string
  toAccountNameNumber: string
  toAccountId: string
  toAccountRoutingNumber: string
  toAccountType: string
  transferCancelable: boolean
  transferFee: number
  transferSpeed: string
  withdrawalDate: string
  achRecurringEndDate?: string
}

export interface StatusTrackerItem {
  eventModelData: WireEvent | AchEvent | CheckOrderEvent | InternalEvent
  statuses: StatusHistory[]
  activityName: string
  completed: boolean
  createdAt?: string
  transactionId: string
  displayName: string
  customerId: string
  updatedAt?: string
  initiatedAt: string
  eventDateTime?: string
  status?: string
  timeSinceStatusChange: number
}

export interface GetDescriptionOpts {
  type: ActivityTypes
  status: StatusTypes
  deliverOnDate: string
}

export enum ActivityTypes {
  WireTransfer = 'WireTransfer',
  ACHTransfer = 'ACHTransfer',
  CheckOrder = 'CheckOrder',
}

export type StatusTypes = WireStatuses | AchStatuses | CheckOrderStatuses

export enum WireStatuses {
  Requested = 'Requested',
  Reviewing = 'Reviewing',
  Processing = 'Processing',
  VerificationRequired = 'VerificationRequired',
  Canceled = 'Canceled',
  Sent = 'Sent',
}

export enum AchStatuses {
  InProcess = 'InProcess',
  Completed = 'Completed',
}

export enum CheckOrderStatuses {
  Confirmed = 'Confirmed',
  InProcess = 'InProcess',
  Shipped = 'Shipped',
}

export interface StatusOpts {
  description: (date?: string) => string | ReactElement
  icon: MuiIconMap
  iconColor?: string
}
